<template>
  <HttpSelectInputView :value="value" :required="required" :errors="errors" :endpoint="endpoint"  @update:value="$emit('update:value', $event)" :title="title">
    <template v-slot:option="{ option }">
      <span class="d-flex align-items-center">
        <AvatarView :url="option.imageUrl"/>
        <span class="ms-1">{{ option.title }}</span>
      </span>
    </template>
  </HttpSelectInputView>
</template>

<script>
import {HttpSelectInputView} from "@/niftybit";
import AvatarView from "@/components/global/AvatarView.vue";

export default {
  name: "PlayerSelectInput",
  components: {HttpSelectInputView, AvatarView},
  emits: ["update:value"],
  props: {
    title: String,
    value: String,
    required: Boolean,
    errors: Array,
    endpoint: String
  }
}
</script>

<style scoped>

</style>
